import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { showAddProductGimworkDBModalReducer } from '../../../redux/slices/components/ManageProducts/manageProductsDataSlice'
import { RootState, useAppDispatch } from '../../../redux/store/store'
import SearcherBar from '../../UIcomponents/SearcherBar/SearcherBar'

const HeaderManageProducts = () => {

    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const searchBarRef = useRef()

    const typeProduct = useSelector((state: RootState) => state.manageProductsData.typeProduct)

    const searchSubmit = useCallback(
        () => {
            
        },
        [],
    )
    

    const handleRequestProduct = () => {
        dispatch( showAddProductGimworkDBModalReducer() )
    }

    return (
        <div className="flex flex-ai-center">
            <p className="title-screen">{t("General:label_273")}</p>
            <SearcherBar style={{ width: "28rem" }} ref={searchBarRef} searchSubmit={searchSubmit} placeholder={t("General:label_029")} />

            <button 
                className="btn-beside-title-screen border-color-text flex flex-ai-center ml-20 pointer"
                onClick={handleRequestProduct}
            >
                <FontAwesomeIcon icon={faPlus} className="fs-18-vh" />
                <p className="text-btn-title-screen color-text ml-10">{typeProduct === "DIGITAL" ? t("ManageProducts:request:label_03") : t("ManageProducts:request:label_02")}</p>
            </button> 
            
        </div>
    )
}

export default React.memo( HeaderManageProducts )